import {Component} from "react";
import "../styles/InfoListStyles.css"
import Fade from 'react-reveal/Fade';

class InfoList extends Component {
    constructor(props) {
        super(props);
    }

    getSideElement(){
        if(this.props.side == "right"){
            return (
                <ol className={"info-list_list"}>
                    {this.props.list.map((item, i) => (
                        <Fade right duration={(i+1)*1000}>
                            <li key={`${i+1}`} className={`info-list_list_items item${i}`}>{item}</li>
                        </Fade>
                    ))}
                </ol>
            );
        } else {
            return(
                <ol className={"info-list_list"}>
                    {this.props.list.map((item, i) => (
                        <Fade left duration={(i+1)*1000}>
                            <li className={`info-list_list_items item${i}`}>{item}</li>
                        </Fade>
                    ))}
                </ol>
            );
        }
    }

    render() {
        return(
            <div className={"info-list"}>
                {this.getSideElement()}
            </div>
        );

    }
}
export default InfoList;